import { render, staticRenderFns } from "./EpisodeArtistSection.vue?vue&type=template&id=f2f21602&scoped=true&"
import script from "./EpisodeArtistSection.vue?vue&type=script&lang=js&"
export * from "./EpisodeArtistSection.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeArtistSection.vue?vue&type=style&index=0&id=f2f21602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f21602",
  null
  
)

export default component.exports